import {
    TUTOR_SIGN_UP, TUTOR_SIGN_UP_FAIL, TUTOR_SIGN_UP_SUCCESS,
    TUTOR_PROFILE_UPDATE, TUTOR_PROFILE_UPDATE_FAIL, TUTOR_PROFILE_UPDATE_SUCCESS,
} from '../Type';
import _ from 'lodash'

import { takeLatest, put } from 'redux-saga/effects';
import {
    tutorSignUp as tutorSignUpApi,
    tutorProfileUpdate as tutorProfileUpdateApi,    
} from '../../Api';


function* tutorSignUp(payload) {
    try {
        const result = yield tutorSignUpApi(payload.data);
        if (result && _.isEmpty(result.errors)) {
            yield put({ type: TUTOR_SIGN_UP_SUCCESS, data: result})
        } else {
            let message = '';
            let errors = result.errors || {};
            for (let item of Object.keys(errors)) {
                let error_part = errors[item];
                for (let msg of error_part) {
                    message += ' ' + msg;
                }
            }
            yield put({ type: TUTOR_SIGN_UP_FAIL, data: {msg: message}})
        }
    } catch (err) {
        yield put({ type: TUTOR_SIGN_UP_FAIL, data: {msg: "NET ERROR"}});
    }
}

export function* watchtutorSignUp(){
    yield takeLatest(TUTOR_SIGN_UP, tutorSignUp)
}

function* tutorProfileUpdate(payload) {
    try {
        const result = yield tutorProfileUpdateApi(payload.data);
        if (result && _.isEmpty(result.errors)) {
            yield put({ type: TUTOR_PROFILE_UPDATE_SUCCESS, data: result})
        } else {
            let message = result.message;
            let errors = result.errors || {};
            for (let item of Object.keys(errors)) {
                let error_part = errors[item];
                for (let msg of error_part) {
                    message += ' ' + msg;
                }
            }
            yield put({ type: TUTOR_PROFILE_UPDATE_FAIL, data: {msg: message}})
        }
    } catch (err) {
        yield put({ type: TUTOR_PROFILE_UPDATE_FAIL, data: {msg: "NET ERROR"}});
    }
}

export function* watchtutorProfileUpdate(){
    yield takeLatest(TUTOR_PROFILE_UPDATE, tutorProfileUpdate)
}